import './index.scss';
import FormDataParser from 'utils/form_data_parser';
import { EventManager } from 'utils/event_manager';

class FormDataSummary extends FormDataParser {
  constructor(formElement, targetSelector, options) {
    super(formElement, { readonly: false, ...options });
    this.$target = this.$form.find(targetSelector);
    this.placeholder = this.$target.data('placeholder');

    this._prepare();

    // First Load
    this.refresh();

    // Handle changes
    this.$form.on('change input', this.inputSelector, e =>
      this.change(e.currentTarget)
    );
    $('.q-select-input', this.$form).qselect('on', 'fetch', () =>
      setTimeout(() => this.refresh(), 300)
    );

    this.$form[0].formDataSummary = this;
  }

  _prepare() {
    const placeholderHtml = `<span class="q-placeholder">${this.placeholder}:</span>`;
    this.$target.append(placeholderHtml);
    this.$main = $('<div class="q-main"></div>');
    this.$target.append(this.$main);

    this.$form.addClass('q-form-data-summary');
    this.$target.addClass('q-summary-tags');
  }

  _bindRemoveEvents() {
    if (!this.options.readonly) {
      this.$target
        .find('.js-summary-tag-remove')
        .off('click.tag_remove')
        .on('click.tag_remove', e => {
          const name = $(e.currentTarget).data('name');
          this.remove(name);
        });

      this.$target
        .find('.js-summary-value-remove')
        .off('click.value_remove')
        .on('click.value_remove', e => {
          const $elem = $(e.currentTarget);
          const name = $elem.data('name');
          const value = $elem.data('value');
          this.removeValue(name, value);
        });
    }
  }

  render() {
    const keys = Object.keys(this.summary);

    if (!keys.length) {
      this.$main.html(
        '<span class="q-empty">Os seus filtros aparecerão aqui.</span>'
      );
      EventManager.publish('formDataSummary.changed', { empty: true });
      return;
    }

    this.$main.html('');

    keys.forEach(name => {
      const item = this.summary[name];
      const $tag = this.buildTag(item);

      this.$main.append($tag);
    });

    EventManager.publish('formDataSummary.changed', { empty: false });
    this._bindRemoveEvents();
  }

  buildTag(item) {
    const MAX_LENGTH = 150;
    let value = '';

    if (item.isMultiple) {
      value = item.display
        .map(
          (
            display,
            i
          ) => `<div class="q-value-item" data-value="${i}">${display} ${
            this.options.readonly
              ? ''
              : `<button type="button"
              class="q-btn-remove js-summary-value-remove"
              data-name="${item.name}"
              data-index="${i}"
              data-value="${item.value[i]}">
              <i class="q-icon q-icon-times-circle"></i>
            </button>`
          }
          </div>`
        )
        .join('');
    } else {
      const displayText =
        item.display.length > MAX_LENGTH
          ? item.display.substring(0, MAX_LENGTH) + '...'
          : item.display;
      value = `<div class="q-single-value-item">${displayText}</div>`;
    }

    return $(`
        <div class="q-summary-tag">
          <div class="q-heading">
            <span class="q-label">${item.label}</span>
            ${
              this.options.readonly
                ? ''
                : // eslint-disable-next-line max-len
                  `<button type="button" class="q-btn-remove js-summary-tag-remove" data-name="${item.name}"><i class="q-icon q-icon-times-circle"></i></button>`
            }
          </div>
          <span class="q-value">${value}</span>
        </div>
      `);
  }

  remove(name) {
    const item = this.summary[name];

    if (item.isMultiple) {
      $(item.value).each((i, value) => {
        this.removeValue(item.name, value);
      });
    } else {
      this.removeValue(item.name, item.value);
    }
  }

  removeValue(name, value) {
    const item = this.summary[name];
    const $input = $(
      `[name="${item.name}"]` + (item.isCheckable ? `[value="${value}"]` : '')
    );

    if ($input.is(':checkbox') || $input.is(':radio')) {
      $input.prop('checked', false);
    } else {
      $input.val('', true);
    }

    $input.trigger('change');
  }

  refresh() {
    const self = this;
    self.summary = {};

    self._getInputs();
    self.$inputs.toArray().forEach(el => self.change(el, false));
    self.render();
  }
}

(function ($) {
  'use strict';

  if (!$.fn.formDataSummary) {
    $.fn.formDataSummary = function (targetSelector, options = null) {
      const formElement = this;

      if (formElement.length > 0) {
        const instance = new FormDataSummary(
          formElement,
          targetSelector,
          options
        );

        return instance.$form;
      } else {
        return this;
      }
    };
  }
})(jQuery);
